export enum MaintenanceStepId {
  MANAGER_INBOX = 'mgr.inbox',
  TENANT_REQUEST = 'tenant.request',
  MANAGER_NEW_REQUEST = 'mgr.newRequest',
  MANAGER_ASSIGN_VENDOR = 'mgr.assignVendor',
  MANAGER_UPDATE_STATUS = 'mgr.updateStatus',
}

export enum MaintenanceSubsceneId {
  PORTAL = 'portal',
  MODAL = 'modal',
  PROCESSING = 'processing',
  SUBMITTED = 'submitted',
  FIELD = 'field',
  OPTION = 'option',
}
